
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(58),
  playerId: Number.withConstraint(x => x >= -1),
  level: Number.withConstraint(x => x >= -1),
  dlr: Number.withConstraint(x => x >= 0),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
  event_mapping_version: Literal(2),
}).And(Partial({
  fps: Number.withConstraint(x => x >= 0),
  maxFps: Number.withConstraint(x => x >= 0),
  memoryUsage: Number.withConstraint(x => x >= 0),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(58),
  playerId: Number.withConstraint(x => x >= -1),
  level: Number.withConstraint(x => x >= -1),
  dlr: Number.withConstraint(x => x >= 0),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 0 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  lang: String.withConstraint(x => x.length <= 5),
}).And(Partial({
  fps: Number.withConstraint(x => x >= 0),
  maxFps: Number.withConstraint(x => x >= 0),
  memoryUsage: Number.withConstraint(x => x >= 0),
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 58;
  